/* Routing */
import { Link } from "react-router-dom";

export default function Header({ locationComp, location, parent, slug }) {

    return(
        <header>
                {parent &&
                    <h1  className="header-title">
                        <div>
                            <Link to={slug}><span className="parent">{ parent }</span></Link>
                            { location &&
                                <span className="location"> / { location }</span>
                            }
                            { locationComp &&
                                <span className="location-comp">{ locationComp }</span>
                            }
                        </div>
                    </h1>
                }
        </header>
    )
}
